import { render, staticRenderFns } from "./appadsTxt.vue?vue&type=template&id=0035a578&scoped=true"
import script from "./appadsTxt.vue?vue&type=script&lang=js"
export * from "./appadsTxt.vue?vue&type=script&lang=js"
import style0 from "./appadsTxt.vue?vue&type=style&index=0&id=0035a578&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0035a578",
  null
  
)

export default component.exports